import { Stack, styled } from '@mui/material';

import { getDesktopHeaderStyle } from '../../../../styles/mui/common';

export const Header = styled(Stack)({
  ...getDesktopHeaderStyle(),
  marginTop: 'var(--spacing-small)',
});
